[
    {
        "id": 0,
        "name": "Gingiva",
        "color": "#ffffff"
    },
    {
        "id": 11,
        "name": "Tooth 11",
        "color": "#1f77b4"
    },
    {
        "id": 12,
        "name": "Tooth 12",
        "color": "#aec7e8"
    },
    {
        "id": 13,
        "name": "Tooth 13",
        "color": "#ff7f0e"
    },
    {
        "id": 14,
        "name": "Tooth 14",
        "color": "#ffbb78"
    },
    {
        "id": 15,
        "name": "Tooth 15",
        "color": "#2ca02c"
    },
    {
        "id": 16,
        "name": "Tooth 16",
        "color": "#98df8a"
    },
    {
        "id": 17,
        "name": "Tooth 17",
        "color": "#d62728"
    },
    {
        "id": 18,
        "name": "Tooth 18",
        "color": "#ff9896"
    },
    {
        "id": 21,
        "name": "Tooth 21",
        "color": "#9467bd"
    },
    {
        "id": 22,
        "name": "Tooth 22",
        "color": "#c5b0d5"
    },
    {
        "id": 23,
        "name": "Tooth 23",
        "color": "#8c564b"
    },
    {
        "id": 24,
        "name": "Tooth 24",
        "color": "#c49c94"
    },
    {
        "id": 25,
        "name": "Tooth 25",
        "color": "#e377c2"
    },
    {
        "id": 26,
        "name": "Tooth 26",
        "color": "#f7b6d2"
    },
    {
        "id": 27,
        "name": "Tooth 27",
        "color": "#7f7f7f"
    },
    {
        "id": 28,
        "name": "Tooth 28",
        "color": "#ff2700"
    },
    {
        "id": 31,
        "name": "Tooth 31",
        "color": "#bcbd22"
    },
    {
        "id": 32,
        "name": "Tooth 32",
        "color": "#dbdb8d"
    },
    {
        "id": 33,
        "name": "Tooth 33",
        "color": "#17becf"
    },
    {
        "id": 34,
        "name": "Tooth 34",
        "color": "#9edae5"
    },
    {
        "id": 35,
        "name": "Tooth 35",
        "color": "#393b79"
    },
    {
        "id": 36,
        "name": "Tooth 36",
        "color": "#5254a3"
    },
    {
        "id": 37,
        "name": "Tooth 37",
        "color": "#6b6ecf"
    },
    {
        "id": 38,
        "name": "Tooth 38",
        "color": "#9c9ede"
    },
    {
        "id": 41,
        "name": "Tooth 41",
        "color": "#637939"
    },
    {
        "id": 42,
        "name": "Tooth 42",
        "color": "#8ca252"
    },
    {
        "id": 43,
        "name": "Tooth 43",
        "color": "#b5cf6b"
    },
    {
        "id": 44,
        "name": "Tooth 44",
        "color": "#cedb9c"
    },
    {
        "id": 45,
        "name": "Tooth 45",
        "color": "#8c6d31"
    },
    {
        "id": 46,
        "name": "Tooth 46",
        "color": "#bd9e39"
    },
    {
        "id": 47,
        "name": "Tooth 47",
        "color": "#e7ba52"
    },
    {
        "id": 48,
        "name": "Tooth 48",
        "color": "#0000ff"
    }
]
